/**
 * JSON text with every integer too large for a JavaScript number written as a string instead, so JSON.parse keeps its
 * digits: OKX order ids (C# long, about 7×10^17) pass Number.MAX_SAFE_INTEGER (about 9×10^15), and parsed as numbers
 * they would come out as a neighbouring id. Only integer literals outside strings change; prices (with a fraction) and
 * every safe integer stay numbers. Text without such an integer is returned as it is.
 */
export function quoteUnsafeIntegers(json: string): string {
  if (!/\d{16}/.test(json)) return json;

  let out = '';
  let from = 0;
  let inString = false;

  for (let i = 0; i < json.length; i++) {
    const char = json[i];

    if (inString) {
      if (char === '\\') i++;
      else if (char === '"') inString = false;
      continue;
    }

    if (char === '"') {
      inString = true;
      continue;
    }

    if (char === '-' || (char !== undefined && char >= '0' && char <= '9')) {
      let end = i + 1;
      while (end < json.length && /[0-9.eE+-]/.test(json[end] ?? '')) end++;

      const token = json.slice(i, end);
      if (/^-?\d+$/.test(token) && !Number.isSafeInteger(Number(token))) {
        out += `${json.slice(from, i)}"${token}"`;
        from = end;
      }
      i = end - 1;
    }
  }

  return from === 0 ? json : out + json.slice(from);
}
